import { components } from "@certn/api/generated-schemas/applicant-portal";
import { Container } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { EmptyState } from "../../../components/empty-state/EmptyState";
import { PaymentCard } from "./components/PaymentCard";

interface PaymentProfilesProps {
  paymentProfiles: components["schemas"]["PaymentProfileList"][];
  statusFilter: "ACTIVE" | "INACTIVE" | "FAILED";
  mutate: () => void;
}

export function PaymentProfilesTab(props: PaymentProfilesProps) {
  const { paymentProfiles, statusFilter, mutate } = props;
  const { t } = useTranslation();

  const filteredPaymentProfiles = paymentProfiles.filter(
    (profile) => profile.status === statusFilter && profile.number
  );

  if (filteredPaymentProfiles.length === 0) {
    return (
      <EmptyState
        illustration="wallet-cards"
        description={
          statusFilter === "ACTIVE"
            ? t("You have no active payment profile.")
            : statusFilter === "INACTIVE"
              ? t("You have no archived payment profiles.")
              : t("You have no failed payment profiles.")
        }
      />
    );
  }

  return (
    <Container
      layout="narrow"
      className={css({ rowGap: "var(--space-3)" })}
      testID="payment-card-container"
    >
      {filteredPaymentProfiles.map((profile) => (
        <PaymentCard
          key={profile.id}
          brand={profile.brand || ""}
          number={profile.number || ""}
          expiryDate={profile.expiry_date || ""}
          owner={profile.owner || ""}
          issuer={profile.issuer || ""}
          id={profile.id}
          status={statusFilter}
          mutate={mutate}
        />
      ))}
    </Container>
  );
}
